import { z } from 'zod';

export const MessageSignatureSchema = z.object({
   signer: z.string(),
   signature: z.string().optional(),
   serializedTransaction: z.string().optional(),
   tokenId: z.string(),
   referralCode: z.string().optional(),
   emailVerificationCode: z.string().optional(),
});

export const AuthTokenSchema = z.object({
   id: z.string(),
   token: z.string(),
});

// export const SignupSchema = z
//    .object({
//       email: z.string().email({ message: 'Invalid email address' }),
//       password: z
//          .string()
//          .min(8, { message: 'Password must be at least 8 characters long' })
//          .regex(/^(?=.*[A-Z])(?=.*[0-9])/, {
//             message: 'Password must contain at least one uppercase letter and one number',
//          }),
//       confirmPassword: z.string().min(8, { message: 'Password must be at least 8 characters long' }),
//       // username: z
//       //    .string()
//       //    .or(z.literal(''))
//       //    .refine((val) => val === '' || (val.length >= 3 && val.length <= 20), {
//       //       message: 'Username must be between 3 and 20 characters long',
//       //    })
//       //    .optional(),
//       firstname: z.string().refine((val) => val.length > 0, { message: 'First name is required' }),
//       lastname: z.string().refine((val) => val.length > 0, { message: 'Last name is required' }),
//       validationCode: z
//          .string()
//          .length(6, { message: 'Validation code must be exactly 6 digits' })
//          .regex(/^[0-9]+$/, { message: 'Validation code must contain only digits' })
//          .optional(),
//       referralCode: z.string().optional(),
//       termsAccepted: z.boolean(),
//       source: z.string().optional(),
//       country: z.string().refine((val) => val.length > 0, { message: 'Country is required' }),
//    })
//    .refine((data) => data.password === data.confirmPassword, {
//       message: 'Passwords do not match',
//       path: ['confirmPassword'],
//    })
//    .refine((data) => data.termsAccepted, {
//       message: 'You must accept the terms and conditions',
//    });

export const SignupInitialSchema = z
   .object({
      email: z.string().email({ message: 'Invalid email address' }),
      firstname: z.string().refine((val) => val.length > 0, { message: 'First name is required' }),
      lastname: z.string().refine((val) => val.length > 0, { message: 'Last name is required' }),
      referralCode: z.string().optional(),
      termsAccepted: z.boolean(),
      source: z.string().optional(),
      country: z.string().refine((val) => val.length > 0, { message: 'Country is required' }),

      utmSource: z.string().optional(),
      utmCampaign: z.string().optional(),
      utmContent: z.string().optional(),
      utmMedium: z.string().optional(),
   })

   .refine((data) => data.termsAccepted, {
      message: 'You must accept the terms and conditions',
   });

export const SignupPasswordSchema = z
   .object({
      password: z
         .string()
         .min(8, { message: 'Password must be at least 8 characters long' })
         .regex(/^(?=.*[A-Z])(?=.*[0-9])/, {
            message: 'Password must contain at least one uppercase letter and one number',
         }),
      confirmPassword: z.string().min(8, { message: 'Password must be at least 8 characters long' }),
   })
   .refine((data) => data.password === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
   });

export const SignupSchema = z
   .object({
      email: z.string().email({ message: 'Invalid email address' }),
      firstname: z.string().refine((val) => val.length > 0, { message: 'First name is required' }),
      lastname: z.string().refine((val) => val.length > 0, { message: 'Last name is required' }),
      referralCode: z.string().optional(),
      termsAccepted: z.boolean(),
      source: z.string().optional(),
      country: z.string().refine((val) => val.length > 0, { message: 'Country is required' }),
      password: z
         .string()
         .min(8, { message: 'Password must be at least 8 characters long' })
         .regex(/^(?=.*[A-Z])(?=.*[0-9])/, {
            message: 'Password must contain at least one uppercase letter and one number',
         }),
      confirmPassword: z.string().min(8, { message: 'Password must be at least 8 characters long' }),
      validationCode: z
         .string()
         .length(6, { message: 'Validation code must be exactly 6 digits' })
         .regex(/^[0-9]+$/, { message: 'Validation code must contain only digits' })
         .optional(),
      utmSource: z.string().optional(),
      utmCampaign: z.string().optional(),
      utmContent: z.string().optional(),
      utmMedium: z.string().optional(),
      newUser: z.boolean().optional(),
   })
   .refine((data) => data.password === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
   })
   .refine((data) => data.termsAccepted, {
      message: 'You must accept the terms and conditions',
   });

export const SignupEmailSchema = z
   .object({
      email: z.string().email({ message: 'Invalid email address' }),
      password: z
         .string()
         .min(8, { message: 'Password must be at least 8 characters long' })
         .regex(/^(?=.*[A-Z])(?=.*[0-9])/, {
            message: 'Password must contain at least one uppercase letter and one number',
         }),
      confirmPassword: z.string().min(8, { message: 'Password must be at least 8 characters long' }),
      validationCode: z
         .string()
         .length(6, { message: 'Validation code must be exactly 6 digits' })
         .regex(/^[0-9]+$/, { message: 'Validation code must contain only digits' })
         .optional(),
   })
   .refine((data) => data.password === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
   });

export const EmailResetSchema = z.object({
   email: z.string().email({ message: 'Invalid email address' }),
   validationCode: z
      .string()
      .length(6, { message: 'Validation code must be exactly 6 digits' })
      .regex(/^[0-9]+$/, { message: 'Validation code must contain only digits' })
      .optional(),
});

export const ValidationCodeSchema = z.object({
   code: z
      .string()
      .length(6, { message: 'Validation code must be exactly 6 digits' })
      .regex(/^[0-9]+$/, { message: 'Validation code must contain only digits' }),
});

export const LoginSchema = z.object({
   email: z.string().email(),
   password: z.string(),
});

export const EmailVerificationSchema = z.object({
   email: z.string().email(),
   newWallet: z.string().optional(),
});

export const EmailVerificationResponseSchema = z.object({
   email: z.string(),
   expiresAt: z.string(),
});

export const PasswordUpdateSchema = z
   .object({
      currentPassword: z.string().optional(),
      newPassword: z
         .string()
         .min(8, { message: 'Password must be at least 8 characters long' })
         .regex(/^(?=.*[A-Z])(?=.*[0-9])/, {
            message: 'Password must contain at least one uppercase letter and one number',
         }),
      confirmPassword: z.string(),
   })
   .refine((data) => data.newPassword === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
   });

export const AddEmailSchema = z
   .object({
      email: z.string().email(),
      password: z
         .string()
         .min(8, { message: 'Password must be at least 8 characters long' })
         .regex(/^(?=.*[A-Z])(?=.*[0-9])/, {
            message: 'Password must contain at least one uppercase letter and one number',
         }),
      confirmPassword: z.string(),
   })
   .refine((data) => data.password === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
   });

export const PasswordResetSchema = z
   .object({
      newPassword: z
         .string()
         .min(8, { message: 'Password must be at least 8 characters long' })
         .regex(/^(?=.*[A-Z])(?=.*[0-9])/, {
            message: 'Password must contain at least one uppercase letter and one number',
         }),
      confirmPassword: z.string(),
   })
   .refine((data) => data.newPassword === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
   });

export const PasswordResetRequestSchema = z.object({
   password: z
      .string()
      .min(8, { message: 'Password must be at least 8 characters long' })
      .regex(/^(?=.*[A-Z])(?=.*[0-9])/, {
         message: 'Password must contain at least one uppercase letter and one number',
      }),
   resetToken: z.string(),
});
